import { render, staticRenderFns } from "./PropertyTypeFilter.vue?vue&type=template&id=d38c71b4&"
import script from "./PropertyTypeFilter.vue?vue&type=script&lang=ts&"
export * from "./PropertyTypeFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports